import React from 'react';
import { Folder, Shield, Zap } from 'lucide-react';

const FeaturePoint = ({ icon: Icon, title, description, color = "text-sortio-primary bg-sortio-primary/20" }) => (
  <div className="flex flex-col items-start">
    <div className={`w-14 h-14 rounded-2xl ${color} flex items-center justify-center mb-4`}>
      <Icon className="h-7 w-7" />
    </div>
    <h4 className="text-lg font-medium mb-2 text-apple-50">{title}</h4>
    <p className="text-apple-300">{description}</p>
  </div>
);

const BusinessOverview = () => {
  return (
    <section id="overview" className="mb-16">
      {/* Section header */}
      <div className="text-center mb-10">
        <h2 className="text-4xl font-semibold mb-5 tracking-tight text-apple-50">
          File <span className="apple-gradient-text">at team scale</span> without migrating
        </h2>
        <p className="text-xl text-apple-300 max-w-3xl mx-auto leading-relaxed font-light">
          Sortio is an intelligent filesystem agent for teams. It learns where each client, matter, or
          project lives in your existing folder structure and files new documents there automatically,
          using rules everyone on your team shares.
        </p>
      </div>

      <div className="bg-apple-700/30 backdrop-blur-md p-10 rounded-3xl border border-apple-600/30 mb-8 relative overflow-hidden">
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-sortio-primary/5 to-sortio-secondary/5 opacity-30"></div>

        <div className="relative z-10">
          <h3 className="text-2xl font-medium mb-8 text-apple-50 text-center">Why teams pick Sortio</h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <FeaturePoint
              icon={Folder}
              title="Zero migration"
              description="Works with the folder structure you already have on Mac, network shares, or cloud drives. No new platform to roll out."
              color="text-sortio-primary bg-sortio-primary/20"
            />

            <FeaturePoint
              icon={Shield}
              title="Shared rules"
              description="Build a sorting rule once. Every teammate files documents the same way, so the folder tree stays consistent."
              color="text-sortio-secondary bg-sortio-secondary/20"
            />

            <FeaturePoint
              icon={Zap}
              title="One admin console"
              description="Manage seats, set LLM policy, and watch usage from a single dashboard. Priority support, 24 hour response."
              color="text-sortio-accent bg-sortio-accent/20"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessOverview;